import { Box, Button, Container, Header, Link, Tabs } from '@amzn/awsui-components-react';
import React, { useContext, useState } from 'react';
import CONSTANTS from 'src/utils/constants';
import TPENavigator from '../TPENavigator';
import { Task, TasksSearchResult } from 'src/models/dashboard/Task';
import OpenTasksGrid from './OpenTasksGrid';
import { DashboardContext } from './DashboardView';
import { ACTIONS } from 'src/services/dashboard/DashboardReducer';

export default function OpenTasksContainer(props: {
    openTasksResult: TasksSearchResult,
    openTasksLoading: boolean,
    onMarkComplete: () => any
}) {
    const { openTasksResult, openTasksLoading, onMarkComplete } = props;
    const { dashboardState, dashboardDispatch } = useContext(DashboardContext);
    const { selectedNotifications } = dashboardState;

    const [ navigateURL, setNavigateURL ] = useState('');

    const getTotalCount = () => {
        if (openTasksLoading) {
            return '...';
        }
        const totalSize = openTasksResult ? openTasksResult.totalSize : 0;
        const displayedSize = openTasksResult?.items?.length || 0;

        if (displayedSize < totalSize) {
            return `${displayedSize}/${totalSize}`;
        }
        return totalSize;
    }

    return <Container
        header={
          <Header
            counter={`(${getTotalCount()})`}
            description="Assigned to me"
            actions={<Button disabled={selectedNotifications?.length == 0} onClick={onMarkComplete}>Mark as completed</Button>}
          >
            Open tasks
          </Header>
        }
        footer={
          <Box textAlign="center">
              <Link
                href="javascript:void(0)"
                variant="primary"
                onFollow={() => setNavigateURL(CONSTANTS.PAGE_NAV.TASKS.URL)}>View all tasks</Link>
          </Box>
        }
      >
        <TPENavigator path={navigateURL}/>
        <OpenTasksGrid openTasksResult={openTasksResult} 
                       isLoading={openTasksLoading} 
                       dashboardView={true} 
                       selectedNotifications={selectedNotifications}
                       setSelectedNotifications={(selectedItems: Task[]) => dashboardDispatch(ACTIONS.SET_SELECTED_NOTIFICATIONS.withPayload(selectedItems))}/>
    </Container>
}